import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import notFoundImage from '@repo/assets/images/404.svg';

export const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col justify-center items-center p-8 bg-white text-center">
      <div className="flex flex-col items-center animate-in slide-in-from-bottom-5 fade-in duration-500">
        <img
          src={notFoundImage}
          alt="404 Not Found"
          className="max-w-100 w-full mb-10 drop-shadow-2xl"
        />
        <h1 className="text-4xl font-black text-slate-900 mb-4 tracking-tight">
          Whoops! Page Lost in Space
        </h1>
        <p className="text-xl text-slate-500 max-w-lg mb-10 leading-relaxed font-medium">
          We couldn't find the page you're looking for. It might have been moved or doesn't exist
          anymore.
        </p>

        <div className="flex flex-wrap justify-center gap-4">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 px-6 py-3 rounded-xl border border-slate-200 bg-white text-slate-700 font-bold hover:bg-slate-50 hover:border-slate-300 transition-all active:scale-[0.98]"
          >
            <ArrowLeft size={20} /> Go Back
          </button>
          <button
            onClick={() => navigate('/')}
            className="flex items-center gap-2 px-8 py-3 rounded-xl bg-primary-600 text-white font-bold hover:bg-primary-700 shadow-lg shadow-primary-200 transition-all active:scale-[0.98]"
          >
            <Home size={20} /> Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};
